// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "header-22Aqk";
var _5 = "heading-356sq";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "header", _5 as "heading" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "header": _4, "heading": _5 }
